import type { ReactElement } from 'react';
import Cart from 'models/Cart';
import Alert from '../Alert';

type Props = { cart: Cart; };

function MaximumMealsAlert({ cart }: Props): ReactElement {
  const { maximum_meals: maxMeals } = cart.validations;

  return (
    <Alert type={cart?.alert?.type}>
      <span className="d-none d-sm-inline">
        You have reached the maximum amount of
        <strong>{` ${maxMeals} meals.`}</strong>
      </span>
      <span className="d-sm-none">
        Max amount of
        <strong>{` ${maxMeals} meals `}</strong>
        reached.
      </span>
    </Alert>
  );
}

export default MaximumMealsAlert;
